import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/touristAttraction/list.vue'
createPage(Page)